<template>
  <div>
    <b-collapse id="showFilters" v-model="showFilters">
      <div class="my-4">
        <b-row>
          <b-col lg="6">
            <v-input-date-range
              label='Filter Bookings by Booking Date'
              :from="filter.bookingDate.from"
              @inputFrom="(from) => {filter.bookingDate.from = from}"
              :to="filter.bookingDate.to"
              @inputTo="(to) => {filter.bookingDate.to = to}"
              :disabled="isBusy"></v-input-date-range>
          </b-col>
          <b-col lg="6">
            <v-input-date-range
            label='Filter Bookings by Pick-up Date'
            :from="filter.pickUpDate.from"
            @inputFrom="(from) => {filter.pickUpDate.from = from}"
            :to="filter.pickUpDate.to"
            @inputTo="(to) => {filter.pickUpDate.to = to}"
            :disabled="isBusy"></v-input-date-range>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <v-select-field
            inputClasses="w-100"
            :multiple="true"
            :taggable="true"
            v-model="filter.agents"
            :options="select2Agents"
            name="agents"
            placeholder="Filter by Agent"
            :disabled="isBusy">
            <span slot="label">Filter by Agent</span>
            </v-select-field>
          </b-col>
          <b-col md="12">
            <b-form-group label="Search by name">
              <b-input-group>
                <b-form-input :value="filter.q" @blur.native="updateSearch" @keyup.native="updateSearchOnEnterKey" placeholder="Filter by client name" :disabled="isBusy" />
                <b-input-group-append>
                  <b-btn :disabled="!filter.q || isBusy" @click="filter.q = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-collapse>
    <div>
      <b-pagination
        size="sm"
        :total-rows="meta.total"
        v-model="meta.current_page"
        :per-page="meta.per_page"
        :disabled="isBusy"></b-pagination>
    </div>
    <transition name="fade">
      <div class="my-4" v-if="!isBusy">
        <draggable v-model="list" :options="{group:'bookings', handle: '.serviceVoucher__card__handle'}">
          <transition-group name="serviceVoucher__cards" tag="div">
            <service-voucher-booking-card v-for="(booking, key) in list" :booking="booking" :key="key"></service-voucher-booking-card>
          </transition-group>
        </draggable>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { bookingServices } from '../../services'
import draggable from 'vuedraggable'
import ServiceVoucherBookingCard from './ServiceVoucherBookingCard'

export default {
  name: 'AddBookingsToServiceVoucher',
  props: [
    'showFilters'
  ],
  data () {
    return {
      list: [],
      links: {
        next: null,
        prev: null,
        first: null,
        last: null
      },
      meta: {
        current_page: null,
        from: null,
        to: null,
        last_page: null,
        path: null,
        per_page: null,
        total: null
      },
      isBusy: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: {
        q: '',
        bookingDate: {
          from: null,
          to: null
        },
        pickUpDate: {
          from: null,
          to: null
        },
        agents: []
      },
      fields: [
        { key: 'client', label: 'Client' },
        { key: 'pick_up', label: 'Pick-Up' },
        { key: 'drop_off', label: 'Drop-off' },
        { key: 'price', label: 'Price' }
      ]
    }
  },
  methods: {
    updateSearch (e) {
      this.filter.q = e.target.value
    },
    updateSearchOnEnterKey (e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.filter.q = e.target.value
      }
    },
    bookingProvider () {
      let filterParams = this.filterParams
      let params = {
        ...JSON.parse(filterParams),
        page: this.meta.current_page || 1
      }

      if (this.sortBy) {
        params.sort = this.sortBy
        if (this.sortDesc) {
          params.sort = params.sort + '-'
        }
      }

      this.isBusy = true
      let xhr = bookingServices.index(params)

      return xhr.then(this.handleBookingProviderSuccess, this.handleBookingProviderFail)
    },
    setLinks (links) {
      if (links) {
        this.$set(this.links, 'first', links.first)
        this.$set(this.links, 'last', links.last)
        this.$set(this.links, 'next', links.next)
        this.$set(this.links, 'prev', links.prev)
      }
    },
    setMeta (meta) {
      if (meta) {
        this.$set(this.meta, 'current_page', meta.current_page)
        this.$set(this.meta, 'from', meta.from)
        this.$set(this.meta, 'to', meta.to)
        this.$set(this.meta, 'last_page', meta.last_page)
        this.$set(this.meta, 'path', meta.path)
        this.$set(this.meta, 'per_page', meta.per_page)
        this.$set(this.meta, 'total', meta.total)
      }
    },
    handleBookingProviderSuccess (res) {
      if (res.hasOwnProperty('data')) {
        this.setLinks((res.data.hasOwnProperty('links')) ? res.data.links : null)
        this.setMeta((res.data.hasOwnProperty('meta')) ? res.data.meta : null)

        this.list = (res.data.hasOwnProperty('data')) ? res.data.data : []
        this.isBusy = false
      }
    },
    handleBookingProviderFail (e) {
      console.log(e.response)
      this.isBusy = false
    },
    getAgentNameById (agentId) {
      let agent = this.agentById(agentId)
      return (agent) ? agent.name : ''
    },
    getLocationNameById (locationId) {
      let location = this.locationById(locationId)
      return (location) ? location.name : ''
    }
  },
  computed: {
    ...mapGetters(
      'agents',
      [
        'agents',
        'agentById',
        'select2Agents'
      ]
    ),
    ...mapGetters(
      'locations',
      [
        'locationById'
      ]
    ),
    filterParams () {
      let params = {
        service_voucher: 0
      }

      if (this.filter.q) {
        params.fullName = this.filter.q.toLowerCase()
      }
      if (this.filter.agents && this.filter.agents.length) {
        params.agents = this.filter.agents.map((agent) => {
          return agent.value
        })
      }

      if (this.filter.bookingDate.from && this.filter.bookingDate.to) {
        params.bookingDate = this.filter.bookingDate.from + ',' + this.filter.bookingDate.to
      }

      if (this.filter.pickUpDate.from && this.filter.pickUpDate.to) {
        params.pickUpDate = this.filter.pickUpDate.from + ',' + this.filter.pickUpDate.to
      }

      return JSON.stringify(params)
    }
  },
  created () {
    this.$store.dispatch('locations/index')
    this.$store.dispatch('travelAgents/index')
    this.$store.dispatch('agents/index')
    this.bookingProvider()
  },
  components: {
    draggable,
    ServiceVoucherBookingCard
  },
  watch: {
    filterParams () {
      this.bookingProvider()
    },
    meta: {
      handler () {
        this.bookingProvider()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .serviceVoucher__cards {
    &-enter, &-leave-to, &-leave-active {
      opacity: 0;
      transform: translateX(-30px);
    }
  }

  .dragArea {
    &.no-items {
      & > div {
        padding: 24px;
        border: 2px dashed #dedede;
        border-radius: 4px;
        color: #dedede;
        &:before {
          content: 'Add booking to service voucher by draging it and dropping it in this area';
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/serviceVouchers/AddBookingsToServiceVoucher.vue